import type { DrawerItem } from '@/components/subject/configs.ts';

const experiments: DrawerItem[] = [

];

const experimentConfig = {
  experiments,
};

export { experimentConfig };
